import axiosInstance from 'api/axiosInstance';
import {
  AddRoleByLicenseRequest,
  AddRoleByLicenseResponse,
  BulkCreatePremiumLicenseRequest,
  BulkCreatePremiumLicenseResponse,
  BulkDeletePremiumLicenseRequest,
  GetPremiumLicensesParams,
  GetPremiumLicensesResponse,
  PremiumLicenseStatsResponse,
} from 'common/types/premiumLicense';

/**
 * Premium License 관련 API 서비스
 */
export const premiumLicenseService = {
  /**
   * Premium License 목록 조회
   * @param params 쿼리 파라미터
   * @returns Premium License 목록
   */
  getList: async (
    params?: GetPremiumLicensesParams
  ): Promise<GetPremiumLicensesResponse> => {
    const response = await axiosInstance.get<GetPremiumLicensesResponse>(
      '/api/v1/users/admin/premium-licenses',
      { params }
    );
    return response.data;
  },

  /**
   * Premium License 일괄 생성
   * @param request 생성 요청 데이터
   * @returns 일괄 생성 결과
   */
  bulkCreate: async (
    request: BulkCreatePremiumLicenseRequest
  ): Promise<BulkCreatePremiumLicenseResponse> => {
    const response = await axiosInstance.post<{
      error: number;
      data: BulkCreatePremiumLicenseResponse;
      message: string;
    }>('/api/v1/users/admin/premium-licenses/bulk', request);
    return response.data.data;
  },

  /**
   * Premium License 일괄 삭제
   * @param request 삭제 요청 데이터
   */
  bulkDelete: async (
    request: BulkDeletePremiumLicenseRequest
  ): Promise<void> => {
    await axiosInstance.delete('/api/v1/users/admin/premium-licenses/bulk', {
      data: request,
    });
  },

  /**
   * Premium License 통계 조회
   * @returns 권한별 통계 데이터
   */
  getStats: async (): Promise<PremiumLicenseStatsResponse> => {
    const response = await axiosInstance.get<PremiumLicenseStatsResponse>(
      '/api/v1/users/admin/premium-licenses/stats'
    );
    return response.data;
  },

  /**
   * 면허번호로 사용자에게 권한 추가
   * @param request 권한 추가 요청 데이터
   * @returns 권한 추가 결과
   */
  addRoleByLicense: async (
    request: AddRoleByLicenseRequest
  ): Promise<AddRoleByLicenseResponse> => {
    const response = await axiosInstance.post<{
      error: number;
      data: AddRoleByLicenseResponse;
      message: string;
    }>('/api/v1/users/admin/add-role', request);
    return response.data.data;
  },
};
